import { createSlice } from "@reduxjs/toolkit";
import { InitialCartoonTypeFormData } from "../../ConstantData/InitialData";

const cartoonTypeSlice = createSlice({
  name: "cartoontype",
  initialState: {
    cartoonTypeList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    initialData: InitialCartoonTypeFormData,
  },
  reducers: {
    getAllCartoonType: (state, action) => {
      state.cartoonTypeList = action.payload;
    },
    getCartoonType: () => {},
    getCartoonTypeDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialCartoonTypeFormData };
    },
    updateCartoonType: (state, action) => {},
    deleteCartoonType: () => {},
  },
});

export const cartoonTypeSliceAction = cartoonTypeSlice.actions;

export default cartoonTypeSlice.reducer;
